import './StockList.css';
import React from 'react';
import * as _ from 'lodash';
import axios from 'axios';
import {combineReducers} from 'redux';
import {connect} from 'react-redux';

import {Box} from 'reactjs-admin-lte';
import {
  Table,
  Row,
  Col,
  Form,
  FormControl,
  FormGroup,
  ControlLabel,
  Button,
} from 'react-bootstrap';
import FontAwsome from 'react-fontawesome';

import * as ReactDataGrid from 'react-data-grid';
import {Editors, Formatters} from 'react-data-grid-addons';

import {
  loadStockList,
} from '../../../../stores/CarDamage/StockReducer';

import {updateDamageItemByPartItem} from '../../../../stores/CarDamage/DamageReducer';

import Highlighter from 'react-highlight-words';

const {DropDownEditor} = Editors;
const {DropDownFormatter} = Formatters;

class StockList extends React.Component {
  constructor(props) {
    super(props);
    props.dispatch(loadStockList({category: '', query: ''}));
  }

  dispatchResize = () => {
    setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);
  };

  searchStock = (e) => {
    e.preventDefault();
    const category = this.searchTypeInput.value;
    const query = this.searchTextInput.value;

    this.props.dispatch(loadStockList({category, query}));
  };

  renderTableData() {
    const {props} = this;
    const {dispatch} = props;

    return (
        <div className="table-responsive"
             style={{maxHeight: '350px', overflow: 'auto'}}>
          <table
              className={'table table-bordered table-striped table-hover table-bordered-solid'}>
            <thead>
            <tr>
              <th className={'selectRow'}></th>
              <th className={'nowrap'}>ชื่ออะไหล่</th>
              <th className={'nowrap'}>จำนวน</th>
              <th className={'nowrap'}>หน่วยนับ</th>
              <th className={'nowrap'}>ประเภท</th>
              <th className={'nowrap'}>ราคาขาย</th>
            </tr>
            </thead>
            <tbody>
            {props.stockList.map(
                (item, index) => this.renderTableRow(item, index))}
            </tbody>
          </table>
        </div>
    );
  }

  updateItem = (item, field) => (e) => {
    let updated = {
      detail: item.name,
      itemnum: item.id,
      [field]: e.target.checked && 1 || 0,
    };
    this.props.dispatch(updateDamageItemByPartItem({
      itemnum: item.id,
      updated,
    }));
  };

  renderTableRow(item, index) {
    const checked = !!_.find(this.props.damageList, {itemnum: item.id});
    let condition_class = '';
    if (checked) {
      condition_class = 'success';
    } else if (item.qty <= 0) {
      condition_class = 'danger';
    } else if (item.qty <= 3) {
      condition_class = 'warning';
    }

    const word = this.searchTextInput && this.searchTextInput.value;

    return (
        <tr key={index}
            className={[
              condition_class,
            ].join(' ')}>
          <td className={'text-center'}><input
              onChange={this.updateItem(item, 'part_flag')}
              type={'checkbox'} checked={checked}
          /></td>
          <td>
            <Highlighter
                textToHighlight={item.name}
                searchWords={[word]} />
          </td>
          <td>{item.qty}</td>
          <td>{item.unit}</td>
          <td>{item.type}</td>
          <td>{item.price}</td>
        </tr>
    );
  }

  render() {
    return (
        <div className={'car-part-stock-list'}>
          <Box loading={this.props.loading.stock}>
            <Box.Header>
              <Box.Title>
                ค้นหารายการ
              </Box.Title>
            </Box.Header>
            <Box.Body>
              <Row>
                <Col md={12}>
                  <Form inline onSubmit={this.searchStock}>
                    <FormGroup controlId="formControlsSelect">
                      <FormControl componentClass="select"
                                   inputRef={
                                     ref => { this.searchTypeInput = ref;}}
                                   placeholder="เลือกประเภทอะไหล่">
                        <option value="">---- ทั้งหมด -----</option>
                        <option value="177">น้ำมันเครื่อง</option>
                        <option value="178">ไส้กรอง</option>
                        <option value="179">ล้อ</option>
                        <option value="180"> ยาง</option>
                      </FormControl>
                    </FormGroup>
                    {' '}
                    <FormGroup controlId="formControlsInput">
                      <FormControl type="text"
                                   inputRef={
                                     ref => { this.searchTextInput = ref;}}
                                   placeholder="ค้นหาอะไหล่..." />
                    </FormGroup>
                    {' '}
                    <Button type="button" onClick={this.searchStock}>
                      <FontAwsome name={'search'} />
                    </Button>
                  </Form>
                </Col>
              </Row><br />
              {this.renderTableData()}
            </Box.Body>
          </Box>
        </div>
    );
  }
}

export default connect(
    (state, props) => ({...state, ...props}),
)(StockList);


// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/StockList/StockList.js